import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentSuccessPage: FC = () => {
  const navigate = useNavigate();

  const handleGoToVouchers = (): void => {
    navigate('/vouchers', { replace: true });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-seasalt p-6">
      <div className="flex flex-col items-center max-w-md w-full">
        <div className="mb-8">
          <i className="pi pi-check-circle text-[5rem] text-primary-100" />
        </div>

        <h1 className="text-3xl font-bold text-primary-100 mb-4 text-center">
          Payment Successful
        </h1>

        <p className="text-lg text-primary-300 text-center mb-6 leading-7">
          Thank you! Voucher purchase process has been completed.
        </p>

        <p className="text-sm text-gray-500 text-center mb-10 leading-5 px-2">
          Please note: It may take a few minutes for your voucher(s) to appear
          in your vouchers section. This happens while we wait for Paystack to
          confirm the payment.
        </p>

        <button
          onClick={handleGoToVouchers}
          className="bg-primary-100 text-white font-semibold text-base py-4 px-8 rounded-xl w-full shadow-md shadow-primary-100/30 hover:opacity-90 transition"
        >
          Go to Vouchers
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
